<template>
  <!-- <v-card
    class="mx-auto start-card"
    max-width="400"
    color="#EEEEFF"
  > -->
  <div class="my-4">
    <v-card
      class="mx-auto"
      width="400"
      color="rgba(0,0,0,0)"
      elevation=0
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    >
      <p v-if="selected!='report'&&changeHover" style="font-size:20px;background-color:rgba(0,0,0,0.1);color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>お問い合わせ</b></p>
      <p v-else-if="selected!='report'" style="font-size:20px;color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>お問い合わせ</b></p>
      <p v-else style="background-color:rgba(0,0,0,0.2);font-size:20px;color:#FFFFFF;"><b>お問い合わせ</b></p>
    </v-card>
    <v-expand-transition>
      <v-card
        v-if="selected=='report'"
        class="mx-auto mt-n4"
        elevation=0
        width="400"
        color="rgba(0,0,0,0.2)"
      >
      <div class="button-container" style="padding-bottom:8px">
        <v-btn class="white--text send-button my-6" v-on:click="openForm" large tile color="#205020" max-width=190><b>お問い合わせフォームへ</b></v-btn>
        <p style="color:#FFF">※Google Formが開きます．</p>
      </div>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- </v-card> -->
</template>
<script>
export default {
  props: ['selected'],
  data() {
    return {
      changeHover: false
    }
  },
  methods:{
    pushed() {
      if (this.selected != 'report'){
        // this.selected = 'report'
        this.$emit("select-mode", {selected: "report"})
      }else {
        // this.selected = ''
        this.$emit("select-mode", {selected: ""})
      }
    },
    openForm() {
      window.open("https://forms.gle/MS4rStUzEdyL8Q9g9", "_blank");
    },
    mouseover: function(){
      this.changeHover = true
    },
    mouseleave: function(){
      this.changeHover = false
    },
  }
}
</script>
<style>
</style>
